import { useState } from "react";
import { Wheel } from "react-custom-roulette";
import { GiClick } from "react-icons/gi";

const SpinWheel = ({ setWiningValue }) => {
  const data = [
    { option: "25%" },
    { option: "30%" },
    { option: "35%" },
    { option: "45%" },
    { option: "55%" },
    { option: "65%" },
    { option: "75%" },
  ];

  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);

  const handleSpinClick = () => {
    const newPrizeNumber = Math.floor(Math.random() * 3);
    setPrizeNumber(newPrizeNumber);

    setMustSpin(true);
  };

  return (
    <div className="relative">
      <Wheel
        mustStartSpinning={mustSpin}
        prizeNumber={prizeNumber}
        data={data}
        fontSize={22}
        onStopSpinning={() => {
          setMustSpin(false);
          setWiningValue(data[prizeNumber].option);
        }}
        backgroundColors={[
          "#FEC60D",
          "#0496BB",
          "#E42220",
          "#C5037E",
          "#444F96",
          "#F38F1D",
          "#058F5B",
        ]}
        // startingOptionIndex={6}
        textColors={["#ffffff"]}
      />
      <div className="z-10 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
        <button
          onClick={handleSpinClick}
          className="bg-[#800080]  text-white border-2 border-solid border-white w-[60px] h-[60px] rounded-full"
        >
          Spin
        </button>
      </div>
     
    </div>
  );
};

export default SpinWheel;
